import { useState } from 'react'
import SkillCard from "./SkillCard"
import Tabs from '../../sharedComponents/Tabs'

export default ({
  soefiaMetrics = {}
}) => {
  console.log('Metrics generated by Soefia:')
  console.log(soefiaMetrics)
  console.log('----------')

  const {
    analysis_result: {
      individual_performance = []
    } = {}
  } = soefiaMetrics

  // const displayedIndividualPerformance = individual_performance[0] || {} // original way of only looking at the first item

  const tabs = individual_performance.map(({ speaker_id }) => speaker_id).sort()
    
  const [selectedTab, setSelectedTab] = useState(tabs[0] || '')

  const displayedIndividualPerformance = individual_performance.find(({ speaker_id }) => speaker_id === selectedTab) || {};

  const showTabSelector = individual_performance.length > 1

  const {
    strands = []
  } = displayedIndividualPerformance;

  console.log('Strands array to display via "analysis_result.individual_performance[].strands": ')
  console.log(strands)

  const skillDisplayNameMap = {
    'Critical_Thinking': 'Critical Thinking',
    'Creative_Thinking': 'Creative Thinking',
    'Resilience': 'Resilience',
  }

  const topStrands = []

  strands
    .filter(({ score_percentage }) => score_percentage > 0)
    .forEach(strand => {
    const {
      skill_name = ''
    } = strand;
    if (topStrands.findIndex(({ skill_name: sn }) => sn === skill_name) < 0) {
      topStrands.push({ skill_name })
    }
  });

  topStrands.forEach(topStrand => {
    const {
      skill_name = ''
    } = topStrand;

    const substrands = strands.filter(({ skill_name: sn, score_percentage }) => (score_percentage > 0 && sn === skill_name))

    let total = 0;
    substrands.forEach(({ score_percentage }) => {
      total += score_percentage;
    });

    const averageScore = total / substrands.length;

    const subSkills = substrands.length > 0 ? substrands : []

    topStrand.score_percentage = averageScore
    topStrand.subSkills = subSkills;
  });

  return (
    <div>
      <div style={{ 
        fontSize: '48px', 
        // fontWeight: 'bold', 
        marginBottom: showTabSelector ? '20px' : '50px',
        // color: '#ffffff',
        textAlign: 'center',
        fontFamily: '"PassionOne-Regular", "Open Sans", sans-serif'
      }}>
        {'My Report Card'}
      </div>

      {
        showTabSelector &&
        <div style={{ marginBottom: '28px' }}>
          <Tabs 
            tabs={tabs} 
            selectedTab={selectedTab} 
            setSelectedTab={setSelectedTab} 
            selectedColor='#f28a22' 
            defaultColor='#d8f6f6' 
            suppressBorderBottom={true}
            containerStyle={{ justifyContent: 'center' }}
          />
        </div>
      }
      {
        topStrands.length > 0 ?
        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
          // justifyContent: 'center'
        }}>
          {
            topStrands.map((skillsData) => {
              const { skill_name = '', score_percentage = '', subSkills = [] } = skillsData;
              const skillName = skillDisplayNameMap[skill_name] || skill_name;
              const score = Math.round(score_percentage)
              return (
                <SkillCard key={skillName} skillName={skillName} score={score} subSkills={subSkills} />
              )
            })
          }
        </div>
        :
        <div style={{
          display: 'flex',
          flexDirection: 'row',
          border: "1px solid #C2C9D1",
          borderRadius: "20px",
          overflow: 'hidden',
          background: '#ffffff',
          color: '#565656',
          padding: '20px',
          width: '50%',
          justifySelf: 'center',
          boxSizing: 'border-box'
        }}>
          <div style={{ flex: 1, textAlign: 'center', }}>
            {'No metrics found'}
          </div>
        </div>
      }
      <div style={{ 
        fontSize: '18px', 
        // fontWeight: 'bold', 
        marginTop: '50px',
        // color: '#ffffff',
        textAlign: 'center',
        // fontFamily: '"PassionOne-Regular", "Open Sans", sans-serif'
      }}>
        {'You may close this tab to return to the experience.'}
      </div>
    </div>
  )
}